import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import './main.css';

import { AuthProvider } from '@/features/auth/providers/AuthProvider';
import { SeasonalFlagsProvider } from '@/shared/providers/SeasonalFlagsProvider';
import { ThemeProvider } from '@/shared/providers/ThemeProvider';
// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ThemeProvider>
        <SeasonalFlagsProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </SeasonalFlagsProvider>
      </ThemeProvider>
    </StrictMode>
  );
}
